module.exports = __webpack_public_path__ + "static/media/tennis_icon.1697bdb3.svg";